import React from "react";
import { Dropdown, DropdownItem } from "flowbite-react";

const SimTableFilters = ({ filters, onFilterChange }) => {
  return (
    <div className="mt-4 mb-4 p-4 bg-white dark:bg-gray-800 flex flex-row items-center space-x-4 justify-between">
      {/* SN Filter */}
      <div>
        <input
          type="text"
          placeholder="Filter by SN"
          value={filters.SN || ""}
          onChange={(e) => onFilterChange("SN", e.target.value)}
          className="outline-none p-2 border border-gray-300 rounded-md dark:bg-gray-700 dark:text-white"
        />
      </div>

      {/* Status Filter */}
      <div className="dark:text-white">
        <Dropdown
          className="dark:text-white"
          color="white"
          label="Filter by Status"
          dismissOnClick={true}>
          <DropdownItem onClick={() => onFilterChange("status", "preActive")}>
            Preactive
          </DropdownItem>
          <DropdownItem onClick={() => onFilterChange("status", "active")}>
            Active
          </DropdownItem>
        </Dropdown>
      </div>
    </div>
  );
};

export default SimTableFilters;
